import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SearchIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SearchIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1438 23.595C19.3637 23.595 23.5953 19.3634 23.5953 14.1435C23.5953 8.92364 19.3637 4.69206 14.1438 4.69206C8.92388 4.69206 4.69231 8.92364 4.69231 14.1435C4.69231 19.3634 8.92388 23.595 14.1438 23.595ZM14.1438 25.6203C20.4822 25.6203 25.6206 20.482 25.6206 14.1435C25.6206 7.80508 20.4822 2.66675 14.1438 2.66675C7.80533 2.66675 2.66699 7.80508 2.66699 14.1435C2.66699 20.482 7.80533 25.6203 14.1438 25.6203Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8539 20.8536C21.2494 20.4582 21.8905 20.4582 22.286 20.8536L29.0371 27.6047C29.4325 28.0002 29.4325 28.6413 29.0371 29.0368C28.6416 29.4323 28.0004 29.4323 27.6049 29.0368L20.8539 22.2858C20.4584 21.8903 20.4584 21.2491 20.8539 20.8536Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SearchIcon;
